import * as React from 'react';
import { Route, Switch } from 'react-router-dom';
import Loadable from 'react-loadable';
import { NProgressLoading as Loading } from 'components';

const Spin = () => <Loading loading />;

const Main = Loadable({
	loader: () => import('./main'),
	loading: Spin,
});

const RefundDetail = Loadable({
	loader: () => import('./routes/refund-detail'),
	loading: Spin,
});

export default ({ match }) => {
	return (
		<Switch>
		  <Route path={`${match.url}/detail/:refundOrderNumber`} component={RefundDetail} />
			<Route exact path={match.url} component={Main} />
		</Switch>
	);
};
